// Tema Renk Paleti - Açık ve Koyu Tema

export type ThemeMode = 'light' | 'dark';

export interface ThemeColors {
  // Primary
  primary: string;
  primaryHover: string;
  primaryLight: string;

  // Backgrounds
  pageBg: string;
  cardBg: string;
  sidebarBg: string;
  headerBg: string;
  hoverBg: string;
  selectedBg: string;
  accentBg: string;
  inputBg: string;

  // Text
  textPrimary: string;
  textSecondary: string;
  textMuted: string;
  textDisabled: string;
  textInverse: string;

  // Borders
  border: string;
  borderLight: string;

  // Accounting / Semantic
  positive: string;
  negative: string;
  error: string;
  errorBg: string;
  errorBorder: string;
  success: string;
  warning: string;

  // Shadows
  shadowColor: string;
  shadowColorStrong: string;
}

export const lightTheme: ThemeColors = {
  // Primary
  primary: '#1e40af',
  primaryHover: '#1d4ed8',
  primaryLight: '#3b82f6',

  // Backgrounds
  pageBg: '#f8fafc',
  cardBg: '#ffffff',
  sidebarBg: '#ffffff',
  headerBg: '#f1f5f9',
  hoverBg: '#f1f5f9',
  selectedBg: '#e0f2fe',
  accentBg: '#eff6ff',
  inputBg: '#ffffff',

  // Text
  textPrimary: '#1e293b',
  textSecondary: '#475569',
  textMuted: '#64748b',
  textDisabled: '#94a3b8',
  textInverse: '#ffffff',

  // Borders
  border: '#e2e8f0',
  borderLight: '#f1f5f9',

  // Accounting / Semantic
  positive: '#16a34a',
  negative: '#dc2626',
  error: '#dc2626',
  errorBg: '#fef2f2',
  errorBorder: '#fecaca',
  success: '#22c55e',
  warning: '#f59e0b',

  // Shadows
  shadowColor: 'rgba(0, 0, 0, 0.04)',
  shadowColorStrong: 'rgba(0, 0, 0, 0.1)',
};

export const darkTheme: ThemeColors = {
  // Primary
  primary: '#3b82f6',
  primaryHover: '#60a5fa',
  primaryLight: '#93c5fd',

  // Backgrounds
  pageBg: '#0f172a',
  cardBg: '#1e293b',
  sidebarBg: '#1e293b',
  headerBg: '#334155',
  hoverBg: '#334155',
  selectedBg: '#1e3a5f',
  accentBg: '#1e3a8a',
  inputBg: '#1e293b',

  // Text
  textPrimary: '#f1f5f9',
  textSecondary: '#cbd5e1',
  textMuted: '#94a3b8',
  textDisabled: '#64748b',
  textInverse: '#0f172a',

  // Borders
  border: '#334155',
  borderLight: '#475569',

  // Accounting / Semantic
  positive: '#4ade80',
  negative: '#f87171',
  error: '#f87171',
  errorBg: '#450a0a',
  errorBorder: '#7f1d1d',
  success: '#4ade80',
  warning: '#fbbf24',

  // Shadows
  shadowColor: 'rgba(0, 0, 0, 0.2)',
  shadowColorStrong: 'rgba(0, 0, 0, 0.4)',
};

export const themes = {
  light: lightTheme,
  dark: darkTheme,
};

// CSS değişkenlerini oluştur
export function getThemeCSSVariables(theme: ThemeColors): string {
  return `
    --color-primary: ${theme.primary};
    --color-primary-hover: ${theme.primaryHover};
    --color-primary-light: ${theme.primaryLight};

    --color-page-bg: ${theme.pageBg};
    --color-card-bg: ${theme.cardBg};
    --color-sidebar-bg: ${theme.sidebarBg};
    --color-header-bg: ${theme.headerBg};
    --color-hover-bg: ${theme.hoverBg};
    --color-selected-bg: ${theme.selectedBg};
    --color-accent-bg: ${theme.accentBg};
    --color-input-bg: ${theme.inputBg};

    --color-text-primary: ${theme.textPrimary};
    --color-text-secondary: ${theme.textSecondary};
    --color-text-muted: ${theme.textMuted};
    --color-text-disabled: ${theme.textDisabled};
    --color-text-inverse: ${theme.textInverse};

    --color-border: ${theme.border};
    --color-border-light: ${theme.borderLight};

    --color-positive: ${theme.positive};
    --color-negative: ${theme.negative};
    --color-error: ${theme.error};
    --color-error-bg: ${theme.errorBg};
    --color-error-border: ${theme.errorBorder};
    --color-success: ${theme.success};
    --color-warning: ${theme.warning};

    --shadow-color: ${theme.shadowColor};
    --shadow-color-strong: ${theme.shadowColorStrong};
  `;
}
